module.exports = __webpack_public_path__ + "static/media/CHei2-Xbold-HKSCS.e1806c2d.svg";